import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ROOT_DIR, LOCATION} from '../../utils/Constants';
//var Instafeed = require("instafeed.js");

class HomepagePhotos extends Component {
  componentDidMount(){
    
  }
  render(){

    return(
      <div className="row">
          <div className="large-12 columns">

            <article className="feature-item">
              
              <h2 className="no-margin feature-heading">Recent Photos</h2>

              <div className="row photos-wrapper">
                <div className="medium-3 columns img-wrapper">
                  <img src="assets/img/feature-photos/halloween.jpg" alt="Halloween decorations at the Corner Club"/>
                  <div className="photo-caption">Strange folks turned up at the Corner Club, 27 October</div>
                </div>

                <div className="medium-3 columns img-wrapper">
                  <img src="assets/img/feature-photos/sunset.jpg" alt="October sunset"/>
                  <div className="photo-caption">Spectacular sunset, result of storm Ophelia, 16 October</div>
                </div>

                <div className="medium-3 columns img-wrapper">
                  <img src="assets/img/feature-photos/seafront.jpg" alt="Canvey Island seafront"/>
                  <div className="photo-caption">Canvey Island seafront</div>
                </div>

                <div className="medium-3 columns img-wrapper">
                  <img src="assets/img/feature-photos/canveyheights.jpg" alt="Canvey Heights"/>
                  <div className="photo-caption">Canvey Heights</div>
                </div>

                
              </div>
                <div className="row">
                  <div className="large-12 columns more-link">
                    <a href="https://www.instagram.com/canveyislandonline/" target="_blank">More photos <i className="fa fa-arrow-circle-o-right fa-lg" aria-hidden="true"></i></a>
                  </div>
                </div>
            </article>

          </div>
        </div>
    );
  }
}
export default HomepagePhotos;


// WEBPACK FOOTER //
// ./src/components/blocks/HomepagePhotos.js